<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-header pb-0">
            <p class="text-uppercase text-center">
              Historial de Pagos Procesados
            </p>
            Total: {{ totalFacturas }} | Páginas: {{ totalPages }}
          </div>
          <hr class="horizontal dark" />
          <div class="card-body px-2 pt-2 pb-2">
            <div
              class="d-flex justify-content-center align-items-center py-4"
              v-if="isLoading"
            >
              Cargando Información
              <pulse-loader :loading="isLoading" :color="color" :size="size" />
            </div>

            <div v-else>
              <form role="form" @submit.stop.prevent="getData">
                <div class="row">
                  <div class="col-md-2">
                    <input
                      class="form-control"
                      type="text"
                      placeholder="Buscar"
                      v-model="modelPagos.filtro"
                    />
                  </div>
                  <div class="col-md-2">
                    <argon-button size="sm" class="bg-gray" type="submit">
                      Buscar
                    </argon-button>
                  </div>
                  <div class="col-md-2">
                    <input
                      class="form-control"
                      type="date"
                      placeholder="Fecha Inicio"
                      v-model="modelPagos.fechaInicio"
                    />
                  </div>
                  <div class="col-md-2">
                    <input
                      class="form-control"
                      type="date"
                      placeholder="Fecha Fin"
                      v-model="modelPagos.fechaFin"
                    />
                  </div>
                  <div class="col-md-2">
                    <argon-button size="sm" class="bg-gray" type="submit">
                      Filtro
                    </argon-button>
                  </div>
                </div>
              </form>

              <div v-if="tableData.length">
                <!-- TABLA -->
                <div class="card-body px-0 pt-0 pb-2" v-if="tableData.length">
                  <div class="table-responsive p-0">
                    <table class="table align-items-center mb-0">
                      <thead>
                        <tr>
                          <th>Reporte</th>
                          <th>Fecha Timbrado</th>
                          <th>UUID</th>
                          <th>Serie</th>
                          <th>Folio</th>
                          <th>RFC</th>
                          <th>Razón Social</th>
                          <th>Forma de Pago</th>
                          <th>Importe</th>
                          <th>UUID Relacionado</th>
                          <th>Acciones</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(row, index) in tableData" :key="index">
                          <td class="text-center align-middle">
                            <input
                              type="checkbox"
                              :value="row.uuid"
                              v-model="indexSeleccionados"
                              class="check-verde"
                            />
                          </td>
                          <td>{{ row.fechaTimbrado }}</td>
                          <td>{{ row.uuid }}</td>
                          <td>{{ row.serie }}</td>
                          <td>{{ row.folio }}</td>
                          <td>{{ row.rfc }}</td>
                          <td>{{ row.razonSocial }}</td>
                          <td style="text-align: center; vertical-align: middle;">{{ row.formaPago }}</td>
                          <td style="text-align: center; vertical-align: middle;">{{ row.importe }}</td>
                          <td style="text-align: center; vertical-align: middle;">{{ row.uuidRelacionado }}</td>
                          <td>
                            <a
                              href="#"
                              class="text-success"
                              title="Descargar PDF"
                              v-b-popover.hover.top="'Descarga PDF'"
                              @click.prevent="downloadPDF(row.uuid)"
                            >
                              <i class="ni ni-cloud-download-95"></i>
                            </a>
                            |
                            <a
                              href="#"
                              class="text-primary btn-tooltip"
                              title="Descargar XML"
                              @click.prevent="downloadXml(row.uuid)"
                            >
                              <i class="ni ni-paper-diploma"></i>
                            </a>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <!-- PAGINACIÓN -->
                <div class="d-flex justify-content-center py-3">
                  <argon-pagination color="primary" size="md">
                    <argon-pagination-item
                      prev
                      :disabled="currentPage === 1"
                      @click="changePage(currentPage - 1)"
                    />

                    <argon-pagination-item
                      v-for="page in totalPages"
                      :key="page"
                      :label="page.toString()"
                      :active="currentPage === page"
                      @click="changePage(page)"
                    />

                    <argon-pagination-item
                      next
                      :disabled="currentPage === totalPages"
                      @click="changePage(currentPage + 1)"
                    />
                  </argon-pagination>
                </div>
                <form role="form" @submit.stop.prevent="getReporte">
                  <div class="row">
                    <div class="col-md-2">
                      UUID para Reporte: {{ indexSeleccionados.length }}
                    </div>
                    <div class="col-md-2">
                      <argon-button size="sm" class="bg-gray" type="submit">
                        Generar Reporte
                      </argon-button>
                    </div>
                  </div>
                </form>
              </div>
              <div v-else class="text-center">Sin Pagos</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import historial from "../../api/historial";
import pagos from "../../api/pagos";
import Swal from "sweetalert2";
import PulseLoader from "../../../node_modules/vue-spinner/src/PulseLoader.vue";
import ArgonPagination from "@/components/ArgonPagination.vue";
import ArgonPaginationItem from "@/components/ArgonPaginationItem.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import * as XLSX from "xlsx";

export default {
  components: {
    PulseLoader,
    ArgonPagination,
    ArgonPaginationItem,
    ArgonButton,
  },

  data() {
    return {
      totalFacturas: 0,
      reporte: "",
      perPage: 10,
      currentPage: 1,
      isLoading: false,
      color: "#535FA8",
      size: "45px",
      tableData: [],
      indexSeleccionados: [],
      modelDownload: {
        token: "",
        type: "",
        uuid: "",
      },
      modelPagos: {
        filtro: "",
        fechaInicio: "",
        fechaFin: "",
        token: "",
        page: 1,
        offset: 0,
        limit: 10,
        statusPago: "PROCESADO",
      },
      genReporte: {
        uuids: [],
        token: "",
        statusPago: "PROCESADO",
      },
      headers: [
        "ID_PAGO",
        "FECHA_EMISION",
        "SERIE",
        "FOLIO",
        "LUGAR_EXPEDICION",
        "EXPORTACION",
        "EMISOR_RFC",
        "EMISOR_RAZON_SOCIAL",
        "EMISOR_USO_CFDI",
        "EMISOR_REGIMEN_FISCAL",
        "RECEPTOR_RFC",
        "RECEPTOR_RAZON_SOCIAL",
        "RECEPTOR_USO_CFDI",
        "RECEPTOR_REGIMEN",
        "RECEPTOR_CP",
        "CONCEPTOS_CANTIDAD",
        "CONCEPTOS_SUBTOTAL",
        "CONCEPTO_IMPORTE",
        "CONCPTOS_NUM_ID",
        "CONCEPTOS_OBJ",
        "TOTAL_RET_IVA",
        "TOTAL_RET_ISR",
        "TOTAL_RET_IEPS",
        "TOTAL_TRAS_BIVA16",
        "TOTAL_TRAS_IIVA16",
        "TOTAL_TRAS_BIVA8",
        "TOTAL_TRAS_IIVA8",
        "TOTAL_TRAS_BIVA0",
        "TOTAL_TRAS_IIVA0",
        "TOTAL_TRAS_BIVAEX",
        "MONTO_TOTAL_PAGOS",
        "PAGO_FECHA",
        "PAGO_FORMA_PAGO",
        "PAGO_MONEDA",
        "PAGO_MONTO",
        "PAGO_TIPO_CAMBIO",
        "PAGO_NUM_OP",
        "PAGO_TIPO_CAD_PAGO",
        "PAGO_CERT_PAGO",
        "PAGO_CAD_PAG",
        "PAGO_SELLO",
        "DOCREL_ID",
        "DOCREL_SERIE",
        "DOCREL_FOLIO",
        "DOCREL_MONEDA",
        "DOCREL_EQUIVALENCIA",
        "DOCREL_PARCIALIDAD",
        "DOCREL_IMPORTE_SALDO_ANT",
        "DOCREL_IMP_PAGADO",
        "DOCREL_SALDO_INS",
        "DOCREL_OBJ",
        "DOREL_IR_BASE_DR",
        "DOREL_IR_IMPUESTO_DR",
        "DOREL_IR_TIPO_FACTOR_DR",
        "DOREL_IR_TASA_DR",
        "DOREL_IR_IMPORTE_DR",
        "DOREL_IT_BASE_DR",
        "DOREL_IT_IMPUESTO_DR",
        "DOREL_IT_TIPO_FACTOR_DR",
        "DOREL_IT_TASA_DR",
        "DOREL_IT_IMPORTE_DR",
        "IMPUESTOSP_R_IMPUESTO",
        "IMPUESTOSP_R_IMPORTE",
        "IMPUESTOSP_T_BASEP",
        "IMPUESTOSP_T_IMPUESTOP",
        "IMPUESTOSP_T_TIPOFACTORP",
        "IMPUESTOSP_T_TASAP",
        "IMPUESTOSP_T_IMPORTEP",
      ],
    };
  },

  computed: {
    totalPages() {
      return Math.ceil(this.totalFacturas / this.perPage);
    },
  },

  created() {
    this.getData(1);
  },

  methods: {
    changePage(page) {
      if (page < 1 || page > this.totalPages) return;

      this.currentPage = page;
      this.getData(page);
    },

    getData(page = 1) {
      this.isLoading = true;

      const offset = (page - 1) * this.perPage;

      this.modelPagos.token = localStorage.getItem("token");
      this.modelPagos.offset = offset;
      this.modelPagos.limit = this.perPage;

      historial.getData(this.modelPagos).then((result) => {
        const resp = result.data;
        this.totalFacturas = resp.total;
        this.tableData = resp.data.map((item) => {
          const data = item.response?.data || {};
          const dataReq = item.request?.complementos?.pagos_20?.pago?.[0] || {};
          //const pago = data.complementos?.pagos_20?.pago?.[0] || {};
          const pago = dataReq || {};
          const docto = pago.docto_relacionado?.[0] || {};
          return {
            fechaTimbrado: data.fecha_timbrado || "",
            uuid: data.uuid || "",
            serie: data.serie || "",
            folio: data.folio || "",
            rfc: data.receptor.rfc || "",
            razonSocial: data.receptor.razon_social || "",
            formaPago: pago.forma_de_pago_p || "",
            importe: pago.monto || "",
            uuidRelacionado: docto.id_documento || "",
          };
        });
        this.isLoading = false;
      });
    },
    downloadPDF(uuid) {
      this.modelDownload.token = localStorage.getItem("token");
      this.modelDownload.uuid = uuid;
      this.modelDownload.type = "pdf";
      pagos
        .getFilePdf(this.modelDownload)
        .then()
        .catch((err) => {
          Swal.fire({
            title: "Error al  Enviar Datos",
            text: err,
            icon: "error",
            confirmButtonColor: "error",
            confirmButtonText: "Continuar",
          });
          this.isLoading = false;
        });
    },
    downloadXml(uuid) {
      this.modelDownload.token = localStorage.getItem("token");
      this.modelDownload.uuid = uuid;
      this.modelDownload.type = "xml";
      pagos
        .getFileXml(this.modelDownload)
        .then()
        .catch((err) => {
          Swal.fire({
            title: "Error al  Recibir Datos",
            text: err,
            icon: "error",
            confirmButtonColor: "error",
            confirmButtonText: "Continuar",
          });
          this.isLoading = false;
        });
    },
    // reporte 1
    // getReporte() {
    //   this.isLoading = true;

    //   this.genReporte.token = localStorage.getItem("token");
    //   this.genReporte.uuids = this.indexSeleccionados;

    //   historial
    //     .getReporte(this.genReporte)
    //     .then((result) => {
    //       const registros = result.data.data || [];
    //       const rows = [];

    //       registros.forEach((item) => {
    //         const req = item.request || {};

    //         const totales = req.complementos?.pagos_20?.totales || {};
    //         const pagos = req.complementos?.pagos_20?.pago || [];

    //         pagos.forEach((pago) => {
    //           const documentos = pago.docto_relacionado || [];

    //           documentos.forEach((doc) => {
    //             const retDR = doc.impuestos_dr?.retenciones_dr?.[0] || {};
    //             const traDR = doc.impuestos_dr?.traslados_dr?.[0] || {};

    //             const retP = pago.impuestos_p?.retenciones_p?.[0] || {};
    //             const traP = pago.impuestos_p?.traslados_p?.[0] || {};

    //             rows.push({
    //               ID_PAGO: "",

    //               FECHA_EMISION: req.fecha_emision || "",

    //               SERIE: req.serie || "",

    //               FOLIO: req.folio || "",

    //               LUGAR_EXPEDICION: req.lugar_expedicion || "",

    //               EXPORTACION: "01",

    //               EMISOR_RFC: req.emisor?.rfc || "",

    //               EMISOR_RAZON_SOCIAL: req.emisor?.razon_social || "",

    //               EMISOR_USO_CFDI: "G03",

    //               EMISOR_REGIMEN_FISCAL: req.emisor?.regimen_fiscal || "",

    //               RECEPTOR_RFC: req.receptor?.rfc || "",

    //               RECEPTOR_RAZON_SOCIAL: req.receptor?.razon_social || "",

    //               RECEPTOR_USO_CFDI: "CP01",

    //               RECEPTOR_REGIMEN: req.receptor?.regimen_fiscal || "",

    //               RECEPTOR_CP: req.receptor?.codigo_postal || "",

    //               CONCEPTOS_CANTIDAD: 1,

    //               CONCEPTOS_SUBTOTAL: 1,

    //               CONCEPTO_IMPORTE: 0,

    //               CONCPTOS_NUM_ID: "SERV0001",

    //               CONCEPTOS_OBJ: "01",

    //               TOTAL_RET_IVA: totales.total_retenciones_iva || "",

    //               TOTAL_RET_ISR: totales.total_retenciones_isr || "",

    //               TOTAL_RET_IEPS: totales.total_retenciones_ieps || "",

    //               TOTAL_TRAS_BIVA16: totales.total_traslados_base_iva16 || "",

    //               TOTAL_TRAS_IIVA16:
    //                 totales.total_traslados_impuesto_iva16 || "",

    //               TOTAL_TRAS_BIVA8: totales.total_traslados_base_iva8 || "",

    //               TOTAL_TRAS_IIVA8: totales.total_traslados_impuesto_iva8 || "",

    //               TOTAL_TRAS_BIVA0: totales.total_traslados_base_iva0 || "",

    //               TOTAL_TRAS_IIVA0: totales.total_traslados_impuesto_iva0 || "",

    //               TOTAL_TRAS_BIVAEX:
    //                 totales.total_traslados_base_iva_exento || "",

    //               MONTO_TOTAL_PAGOS: totales.monto_total_pagos || "",

    //               PAGO_FECHA: pago.fecha_pago || "",

    //               PAGO_FORMA_PAGO: pago.forma_de_pago_p || "",

    //               PAGO_MONEDA: pago.moneda_p || "",

    //               PAGO_MONTO: pago.monto || "",

    //               PAGO_TIPO_CAMBIO: pago.tipo_cambio_p || "",

    //               PAGO_NUM_OP: pago.num_operacion || "",

    //               PAGO_TIPO_CAD_PAGO: pago.tipo_cadena_pago || "",

    //               PAGO_CERT_PAGO: pago.certificado_pago || "",

    //               PAGO_CAD_PAG: pago.cadena_pago || "",

    //               PAGO_SELLO: pago.sello_pago || "",

    //               DOCREL_ID: doc.id_documento || "",

    //               DOCREL_SERIE: doc.serie || "",

    //               DOCREL_FOLIO: doc.folio || "",

    //               DOCREL_MONEDA: doc.moneda_dr || "",

    //               DOCREL_EQUIVALENCIA: doc.equivalencia_dr || "",

    //               DOCREL_PARCIALIDAD: doc.num_parcialidad || "",

    //               DOCREL_IMPORTE_SALDO_ANT: doc.imp_saldo_ant || "",

    //               DOCREL_IMP_PAGADO: doc.imp_pagado || "",

    //               DOCREL_SALDO_INS: doc.imp_saldo_insoluto || "",

    //               DOCREL_OBJ: doc.objeto_imp_dr || "",

    //               DOREL_IR_BASE_DR: retDR.base_dr || "",

    //               DOREL_IR_IMPUESTO_DR: retDR.impuesto_dr || "",

    //               DOREL_IR_TIPO_FACTOR_DR: retDR.tipo_factor_dr || "",

    //               DOREL_IR_TASA_DR: retDR.tasa_o_cuota_dr || "",

    //               DOREL_IR_IMPORTE_DR: retDR.importe_dr || "",

    //               DOREL_IT_BASE_DR: traDR.base_dr || "",

    //               DOREL_IT_IMPUESTO_DR: traDR.impuesto_dr || "",

    //               DOREL_IT_TIPO_FACTOR_DR: traDR.tipo_factor_dr || "",

    //               DOREL_IT_TASA_DR: traDR.tasa_o_cuota_dr || "",

    //               DOREL_IT_IMPORTE_DR: traDR.importe_dr || "",

    //               IMPUESTOSP_R_IMPUESTO: retP.impuesto_p || "",

    //               IMPUESTOSP_R_IMPORTE: retP.importe_p || "",

    //               IMPUESTOSP_T_BASEP: traP.base_p || "",

    //               IMPUESTOSP_T_IMPUESTOP: traP.impuesto_p || "",

    //               IMPUESTOSP_T_TIPOFACTORP: traP.tipo_factor_p || "",

    //               IMPUESTOSP_T_TASAP: traP.tasa_o_cuota_p || "",

    //               IMPUESTOSP_T_IMPORTEP: traP.importe_p || "",
    //             });
    //           });
    //         });
    //       });

    //       const ws = XLSX.utils.json_to_sheet(rows, { header: this.headers });

    //       const wb = XLSX.utils.book_new();

    //       XLSX.utils.book_append_sheet(wb, ws, "PAGOS");

    //       XLSX.writeFile(wb, "Plugin_Pagos.xlsx");
    //     })
    //     .finally(() => {
    //       this.isLoading = false;
    //     });
    // },
    getReporte() {
      this.isLoading = true;

      this.genReporte.token = localStorage.getItem("token");
      this.genReporte.uuids = this.indexSeleccionados;

      historial
        .getReporte(this.genReporte)
        .then((result) => {
          const registros = result.data.data || [];
          const rows = [];

          registros.forEach((item) => {
            const req = item.request || {};

            const totales = req.complementos?.pagos_20?.totales || {};
            const pago = req.complementos?.pagos_20?.pago?.[0] || {};
            const doc = pago.docto_relacionado?.[0] || {};

            const retDR = doc.impuestos_dr?.retenciones_dr?.[0] || {};
            const traDR = doc.impuestos_dr?.traslados_dr?.[0] || {};

            const retP = pago.impuestos_p?.retenciones_p?.[0] || {};
            const traP = pago.impuestos_p?.traslados_p?.[0] || {};

            rows.push({
              ID_PAGO: "",

              FECHA_EMISION: req.fecha_emision || "",
              SERIE: req.serie || "",
              FOLIO: req.folio || "",
              LUGAR_EXPEDICION: req.lugar_expedicion || "",
              EXPORTACION: "01",

              EMISOR_RFC: req.emisor?.rfc || "",
              EMISOR_RAZON_SOCIAL: req.emisor?.razon_social || "",
              EMISOR_USO_CFDI: "G03",
              EMISOR_REGIMEN_FISCAL: req.emisor?.regimen_fiscal || "",

              RECEPTOR_RFC: req.receptor?.rfc || "",
              RECEPTOR_RAZON_SOCIAL: req.receptor?.razon_social || "",
              RECEPTOR_USO_CFDI: "CP01",
              RECEPTOR_REGIMEN: req.receptor?.regimen_fiscal || "",
              RECEPTOR_CP: req.receptor?.codigo_postal || "",

              CONCEPTOS_CANTIDAD: 1,
              CONCEPTOS_SUBTOTAL: 1,
              CONCEPTO_IMPORTE: 0,
              CONCPTOS_NUM_ID: "SERV0001",
              CONCEPTOS_OBJ: "01",

              TOTAL_RET_IVA: totales.total_retenciones_iva || "",
              TOTAL_RET_ISR: totales.total_retenciones_isr || "",
              TOTAL_RET_IEPS: totales.total_retenciones_ieps || "",

              TOTAL_TRAS_BIVA16: totales.total_traslados_base_iva16 || "",
              TOTAL_TRAS_IIVA16: totales.total_traslados_impuesto_iva16 || "",
              TOTAL_TRAS_BIVA8: totales.total_traslados_base_iva8 || "",
              TOTAL_TRAS_IIVA8: totales.total_traslados_impuesto_iva8 || "",
              TOTAL_TRAS_BIVA0: totales.total_traslados_base_iva0 || "",
              TOTAL_TRAS_IIVA0: totales.total_traslados_impuesto_iva0 || "",
              TOTAL_TRAS_BIVAEX: totales.total_traslados_base_iva_exento || "",
              MONTO_TOTAL_PAGOS: totales.monto_total_pagos || "",

              PAGO_FECHA: pago.fecha_pago || "",
              PAGO_FORMA_PAGO: pago.forma_de_pago_p || "",
              PAGO_MONEDA: pago.moneda_p || "",
              PAGO_MONTO: pago.monto || "",
              PAGO_TIPO_CAMBIO: pago.tipo_cambio_p || "",
              PAGO_NUM_OP: pago.num_operacion || "",
              PAGO_TIPO_CAD_PAGO: pago.tipo_cadena_pago || "",
              PAGO_CERT_PAGO: pago.certificado_pago || "",
              PAGO_CAD_PAG: pago.cadena_pago || "",
              PAGO_SELLO: pago.sello_pago || "",

              DOCREL_ID: doc.id_documento || "",
              DOCREL_SERIE: doc.serie || "",
              DOCREL_FOLIO: doc.folio || "",
              DOCREL_MONEDA: doc.moneda_dr || "",
              DOCREL_EQUIVALENCIA: doc.equivalencia_dr || "",
              DOCREL_PARCIALIDAD: doc.num_parcialidad || "",
              DOCREL_IMPORTE_SALDO_ANT: doc.imp_saldo_ant || "",
              DOCREL_IMP_PAGADO: doc.imp_pagado || "",
              DOCREL_SALDO_INS: doc.imp_saldo_insoluto || "",
              DOCREL_OBJ: doc.objeto_imp_dr || "",

              DOREL_IR_BASE_DR: retDR.base_dr || "",
              DOREL_IR_IMPUESTO_DR: retDR.impuesto_dr || "",
              DOREL_IR_TIPO_FACTOR_DR: retDR.tipo_factor_dr || "",
              DOREL_IR_TASA_DR: retDR.tasa_o_cuota_dr || "",
              DOREL_IR_IMPORTE_DR: retDR.importe_dr || "",

              DOREL_IT_BASE_DR: traDR.base_dr || "",
              DOREL_IT_IMPUESTO_DR: traDR.impuesto_dr || "",
              DOREL_IT_TIPO_FACTOR_DR: traDR.tipo_factor_dr || "",
              DOREL_IT_TASA_DR: traDR.tasa_o_cuota_dr || "",
              DOREL_IT_IMPORTE_DR: traDR.importe_dr || "",

              IMPUESTOSP_R_IMPUESTO: retP.impuesto_p || "",
              IMPUESTOSP_R_IMPORTE: retP.importe_p || "",

              IMPUESTOSP_T_BASEP: traP.base_p || "",
              IMPUESTOSP_T_IMPUESTOP: traP.impuesto_p || "",
              IMPUESTOSP_T_TIPOFACTORP: traP.tipo_factor_p || "",
              IMPUESTOSP_T_TASAP: traP.tasa_o_cuota_p || "",
              IMPUESTOSP_T_IMPORTEP: traP.importe_p || "",
            });
          });

          const ws = XLSX.utils.json_to_sheet(rows, {
            header: this.headers,
          });

          const wb = XLSX.utils.book_new();

          XLSX.utils.book_append_sheet(wb, ws, "REPORTE PAGOS");

          XLSX.writeFile(
            wb,
            `Reporte_Pagos_${new Date().toISOString().slice(0, 10)}.xlsx`,
          );
        })
        .catch((err) => {
          console.error(err);
          this.$toast?.error?.("Error al generar el reporte.");
        })
        .finally(() => {
          this.isLoading = false;
          this.indexSeleccionados = [];
        });
    },
  },
};
</script>
